import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { socialProjectBookingExportColumns } from '../../config/exportColumns/socialProjectBookingExportColumns'
import { appAllGetSocialProjectBooking } from '../../store/socialprojectbooking'
import TableFilter from './tableFilter'

function SocialProjectBooking() {
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Social Project Donation</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(appAllGetSocialProjectBooking({ ...params, loading: false }))
							}
							filters={{}}
							columns={socialProjectBookingExportColumns}
							fileName="Social Project Bookings"
							sheetName="Social Project Booking List"
							buttonText="Export Social Project Bookings"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default SocialProjectBooking
